import { render, staticRenderFns } from "./PaymentdetailShipper.vue?vue&type=template&id=4c87e0d2"
import script from "./PaymentdetailShipper.vue?vue&type=script&lang=js"
export * from "./PaymentdetailShipper.vue?vue&type=script&lang=js"
import style0 from "./PaymentdetailShipper.vue?vue&type=style&index=0&id=4c87e0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports